import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useInternalCustomerActions } from 'redux/actions/internal/Customers'
import {
  selectCustomerOptions,
  selectCustomers,
  selectCustomersById,
  selectCustomersFetchStatus
} from 'redux/selectors/internal/Customers'

/**
 * Our customers, fetched if they have not been read yet.
 *
 * The effect lives here rather than in each consumer, so the in-flight guard
 * is shared and the dependency cannot be forgotten by a copy.
 */
export const useInternalCustomers = () => {
  const { tryGetAllCustomers } = useInternalCustomerActions()

  const customers = useSelector(selectCustomers)
  const customersById = useSelector(selectCustomersById)
  const customerOptions = useSelector(selectCustomerOptions)
  const fetchStatus = useSelector(selectCustomersFetchStatus)

  useEffect(() => {
    tryGetAllCustomers()
  }, [tryGetAllCustomers])

  return {
    customerOptions,
    customers,
    customersById,
    error: fetchStatus === 'error',
    loading: fetchStatus === 'idle' || fetchStatus === 'fetching'
  }
}
